import * as React from 'react';
import * as Tgcc from '../../tgccGlobal';
import { CSSProperties } from 'react';
import { ShopItemCloseUpInCart } from './ShopItemCloseupInCart'

const rowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    color: 'black',
    lineHeight: '24px',
    fontSize: '18px',
    alignItems: 'flex-start',
    paddingBottom: '5px',
    marginBottom: '10px',
    borderBottom: '1px solid black'
}
const headerColumnStyle: CSSProperties = {
    display: 'flex',
    flexBasis: '100%',
    flex: '1'
}
const columnStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '100%',
    flex: '1',
    alignItems: 'space-between'
}
const doubleColumnStyle: CSSProperties = {
    display: 'flex',
    flexBasis: '100%',
    flex: '2'
}
const removeStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'flexEnd',
    fontSize: '12px',
    cursor: 'pointer'
}
const imgStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    maxWidth: '150px',
    margin: '10px auto',
    cursor: 'pointer'
}
const proofStyle: CSSProperties = {
    display: 'flex',
    color: 'darkgray'
}
const sizeStyle: CSSProperties = {
    display: 'flex'
}
const priceStyle: React.CSSProperties = {
    display: 'flex',
}
const quantityStyle: CSSProperties = {
    display: 'flex',
    width: '50px',
    border: '1px solid black',
    textAlign: 'right'
}
type Props = {
    cartItem: Tgcc.WebStoreCartItem;
    removeCallback: (itemId: number,size:string) => void;
    changeQtyCallback: (itemId: number, size:string, qty: number) => void;
}

class StateType {
    showCloseUp: boolean
}

export class ShopCartItem extends React.Component<Props, any>{
    state: StateType = {
        showCloseUp: false
    }
    onRemoveClick = (evt: any) => {
        if (this.props.removeCallback)
            this.props.removeCallback(this.props.cartItem.id,this.props.cartItem.size);
    }
    onChangeQuantity = (evt: any) => {
        if (evt.currentTarget)
            this.props.changeQtyCallback(this.props.cartItem.id,this.props.cartItem.size, parseInt(evt.currentTarget.value));
    }
    showItemCloseUp = (evt: any) => {
        this.setState({ showCloseUp: true });
    }
    clearPopup = () => this.setState({ showCloseUp: false });
    render() {
        var imgPath = Tgcc.getProofPath(this.props.cartItem.tBanker.proofId);
        var itemCloseUp = this.state.showCloseUp ? <ShopItemCloseUpInCart proofId={this.props.cartItem.tBanker.proofId} clearStateCallback={this.clearPopup} /> : <div></div>;
        return (
            <div key={this.props.cartItem.id} style={rowStyle} className="shopCartItem">
                {itemCloseUp}
                <div style={doubleColumnStyle}>
                    <img style={imgStyle} className="shopCartItemImg" src={imgPath} onClick={this.showItemCloseUp} />
                </div>
                <div style={columnStyle}>
                    <div style={proofStyle}>{this.props.cartItem.tBanker.proofId}</div>
                    <div style={sizeStyle}>{this.props.cartItem.size ?? 'One size'}</div>
                </div>
                <div style={columnStyle}>
                    <div style={priceStyle}>${this.props.cartItem.tBanker.price.toFixed(2)}</div>
                </div>
                <div style={columnStyle}>
                    <input style={quantityStyle} type="number" min="1" max="99" value={this.props.cartItem.quantity} onChange={this.onChangeQuantity} />
                </div>
                <div style={columnStyle}>
                    <div style={priceStyle}>${(this.props.cartItem.quantity * this.props.cartItem.tBanker.price).toFixed(2)}</div>
                    <div style={removeStyle}>
                        <a onClick={this.onRemoveClick}>Remove</a>
                    </div>
                </div>
            </div>
        )
    }
}

